<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 4.33301L9.33301 8L13 11.667L11.667 13L8 9.33301L4.33301 13L3 11.667L6.66699 8L3 4.33301L4.33301 3L8 6.66699L11.667 3L13 4.33301Z"
            fill="#485478"
        />
    </svg>
</template>
